/**
 * system.config.js (doctor)
 *
 * A system config file contains ONLY declarative metadata that is
 * local to the frontend build (things a backend wouldn't necessarily
 * own, like a brand icon or a default landing module). It contains
 * zero business logic and zero React code — just data.
 */
export default {
  id: "docteur",
  brandIcon: "🩺",
  defaultModule: "acceuil",
  footerNote: "Doctor ERP · Clinical Suite",
};
